import React from 'react';
import { Check, ArrowRight, Lock } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { trackMetaEvent, getCheckoutUrlWithFbclid } from '../hooks/useMetaPixel';
const CHECKOUT_URL = 'https://dolaresenarg.shop/cart/45155071655983:1';
export function Pricing() {
  return <section id="pricing" className="py-24 relative overflow-hidden" data-id="element-79">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[600px] bg-purple-600/10 blur-[120px] rounded-full pointer-events-none" data-id="element-80"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-81">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-82">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-83">
            Una Oferta que no podés dejar pasar
          </h2>
          <p className="text-xl text-slate-400" data-id="element-84">
            El conocimiento para generar ingresos en dólares, por menos de lo
            que cuesta una cena para dos.
          </p>
        </div>

        <div className="max-w-lg mx-auto bg-slate-900 rounded-3xl border-2 border-purple-500/50 shadow-[0_0_50px_rgba(168,85,247,0.15)] overflow-hidden" data-id="element-85">
          <div className="bg-gradient-to-r from-purple-600 to-blue-600 p-6 text-center" data-id="element-86">
            <h3 className="text-2xl font-bold text-white" data-id="element-87">
              Pack Completo "Dólares con IA"
            </h3>
            <p className="text-purple-100 mt-2" data-id="element-88">Ebook + 6 Bonos Exclusivos</p>
          </div>

          <div className="p-8 md:p-10" data-id="element-89">
            <div className="flex justify-center items-center gap-4 mb-4" data-id="element-90">
              <span className="text-2xl text-slate-500 line-through font-bold" data-id="element-91">
                $150.000 ARS
              </span>
              <span className="bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-sm font-bold" data-id="element-92">
                Ahorrás 82%
              </span>
            </div>

            <div className="text-center mb-8" data-id="element-93">
              <span className="text-6xl font-extrabold text-white tracking-tight" data-id="element-94">
                $26.960
              </span>
              <span className="text-xl text-slate-400 font-medium ml-2" data-id="element-95">
                ARS
              </span>
              <p className="text-sm text-slate-500 mt-2" data-id="element-96">
                Pago único. Acceso de por vida.
              </p>
            </div>

            <div className="mb-8" data-id="element-97">
              <p className="text-center text-sm font-bold text-purple-400 uppercase tracking-wider mb-4" data-id="element-98">
                La oferta expira en:
              </p>
              <CountdownTimer data-id="element-99" />
            </div>

            <ul className="space-y-4 mb-8" data-id="element-100">
              {['Ebook: Dólares con IA', 'Bono 1: Plantillas Cierra-Clientes', 'Bono 2: Guía Anti-Comisiones', 'Bono 3: 100 Prompts Maestros', "Bono 4: Masterclass 'Primer Cliente'", 'Bono 5: Tracker Financiero', 'Bono 6: Comunidad Privada'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-101">
                  <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0" data-id="element-102">
                    <Check className="w-4 h-4 text-green-400" data-id="element-103" />
                  </div>
                  <span className="text-slate-300 font-medium" data-id="element-104">{item}</span>
                </li>)}
            </ul>

            <a href={getCheckoutUrlWithFbclid(CHECKOUT_URL)} target="_blank" rel="noopener noreferrer" onClick={() => trackMetaEvent('InitiateCheckout')} className="w-full group relative inline-flex items-center justify-center gap-3 px-8 py-5 bg-green-400 hover:bg-green-300 text-slate-950 font-bold text-lg rounded-xl transition-all duration-300 shadow-[0_0_30px_rgba(74,222,128,0.3)] hover:shadow-[0_0_40px_rgba(74,222,128,0.5)] hover:-translate-y-1" data-id="element-105">
              ACCEDER AL EBOOK + 6 BONOS AHORA
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-106" />
            </a>

            <div className="flex items-center justify-center gap-2 mt-6 text-slate-500 text-sm" data-id="element-107">
              <Lock className="w-4 h-4" data-id="element-108" />
              <span data-id="element-109">Pago 100% seguro y encriptado</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}